export class Cell {
    constructor(colId: number, rowId: number,inputType:string ='inputNumber',disabled:boolean= false,value:any= null) {
        this.colId = colId;
        this.rowId = rowId;
        this.disabled = disabled;
        this.inputType = inputType;
        this.value = value;
    }
    colId: number;
    rowId: number;
    disabled:boolean;
    inputType:string;
    value:any;
}